import { useAbility } from "./useAbility.jsx";

export function useClaimPermissions() {
  const { can } = useAbility();
  const domain = "Claim";

  return {
    canExportZip: (claim) => can(domain, "exportZip", { claim }),
    canUpdate: (claim) => can(domain, "update", { claim }),
    canUpdateForm: (claim) => can(domain, "updateForm", { claim }),
    canGeneratePdf: (claim) => can(domain, "generatePdf", { claim }),
  };
}
